export default __webpack_public_path__ + "static/media/folder.cbdae17d.svg";